import Axios from 'axios';

class ShiftsService {
  getAll() {
    return Axios.get('/admin/shifts')
      .then(({ data }) => data);
  }
}

export default new ShiftsService();
